import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { CircularProgress } from "@mui/material";
import "./SuccessHandler.sass";
import { BASE } from "../basedata/constants";
import { apiUser } from "../basedata/apiCall";
import { useStep } from "../context/StepContext"

const SuccessHandler = () => {
  const { t } = useTranslation(); 
  const { setStep } = useStep();

  const [clearFlow, setClearFlow] = useState(false);

  const [buyLink, setBuyLink] = useState(BASE.company.call_to_action.ticket);

  const [saffePending, setSaffePending] = useState(false);

  const verifyBiometry = async (userToken:any) => {
    try{
      const _response = await apiUser.post(`/biometry/onboarding/user-jorney`, {flowId: userToken})
      if(_response.data.status === 'success'){
        sessionStorage.setItem('document_type', _response.data.document_type || 'cpf')
        const _current_location = window.location.pathname
        if(_response.data.message === 'done'){
            return setBuyLink(_response.data.userInformation?.callbackURL || BASE.company.call_to_action.ticket)
        }else{
          return window.location.href = '/'
        }
      }

      setTimeout(() => {
        verifyBiometry(userToken)
      }, 3000);
    }catch(e){
      setTimeout(() => {
        verifyBiometry(userToken)
      }, 3000);
    }
  }

  useEffect(() => {
    setStep(6);
    verifyBiometry(window.sessionStorage.getItem('token'))
  }, [])


  useEffect(() => {
    const _temp_language = sessionStorage.getItem('language') || 'pt'
    const _clearFlow = sessionStorage.getItem('clear_flow')
    const _temptoken = sessionStorage.getItem('token') || ''

    sessionStorage.clear()
    sessionStorage.setItem('success_flow', 'true')
    sessionStorage.setItem('language', _temp_language)
    sessionStorage.setItem('token', _temptoken)
    if(_clearFlow && _clearFlow === 'true'){
      setClearFlow(true)
    }

    if (_temptoken.trim()) {
      setSaffePending(true);
      apiUser
        .post('/user/send/saffer', { userId: _temptoken.trim() })
        .catch((err) => {
          console.error('[user/send/saffer]', err);
        })
        .finally(() => {
          setSaffePending(false);
        });
    }
  }, []);


  return (
    <div className="success-container">
      <div className="left-side"></div> 
      <div className="right-side">
        <div className="success-card">
          <img className="logo" src={BASE.company.logo} alt={BASE.company.name} />
          <h1 className="success_title">
            Cadastro concluído!
          </h1>
          <div className="success-message-text">
            <p className="success-message">
              Seu cadastro de biometria facial foi concluído com sucesso. <br/><br/>
A partir de agora, sua face poderá ser utilizada para autenticar compras com segurança, praticidade e agilidade nos estabelecimentos e eventos parceiros da Bepass Pay.<br/>
Quando for realizar um pagamento, basta utilizar o reconhecimento facial para confirmar a transação.<br/><br/>
Aproveite essa nova experiência!
              </p>
          </div>
          {/* <img
            src="/Illustration-success.svg"
            className="no-svg-tip"
            alt="Sucesso!"
          /> */}
          
          {saffePending && (
            <div
              className="saffe-feedback saffe-feedback--loading saffe-feedback--spinner-only"
              role="status"
              aria-busy="true"
            >
              <CircularProgress
                size={32}
                sx={{ color: "var(--primary-500)" }}
              />
            </div>
          )}
          

            {/* <button onClick={() => {window.location.href = 'https://futebolcard.com'}} className="continue-button btn-ghost">
              {t("success_page.action_guest_button")}
            </button> */}
        </div>
      </div>
    </div>
  );
};

export default SuccessHandler;
